import type {
  HeatmapClicksQueryResponse,
  HeatmapClicksQueryVariables,
} from '~/modules/heatmap/graphql/queries/heatmapClicks.generated';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { IClickMapPoint } from '~/modules/heatmap/types';
import type { UseQueryOptions } from '@tanstack/react-query';

import { HeatmapClicksDocument } from '~/modules/heatmap/graphql/queries/heatmapClicks.generated';
import { HEATMAP_QUERY_KEYS } from '../../websocket';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomHeatmapClicksResponse extends HeatmapClicksQueryResponse {
  heatmapClicks: IClickMapPoint[];
  headers: BaseHeaderResponse;
}

export const useCustomHeatmapClicksQuery = <TData = CustomHeatmapClicksResponse, TError = unknown>(
  variables: HeatmapClicksQueryVariables,
  options?: UseQueryOptions<CustomHeatmapClicksResponse, TError, TData>,
) => {
  return useQuery<CustomHeatmapClicksResponse, TError, TData>(
    [HEATMAP_QUERY_KEYS.clicks, variables],
    appFetcherCustom<CustomHeatmapClicksResponse, HeatmapClicksQueryVariables>(
      HeatmapClicksDocument,
      variables,
    ),
    options,
  );
};

useCustomHeatmapClicksQuery.getKey = (variables?: HeatmapClicksQueryVariables) => [
  HEATMAP_QUERY_KEYS.clicks,
  variables,
];
